// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from "./utils/api.js";
import http from "./utils/http.js";
import hbtjs from "./utils/hbtUtil.js";
import filters from './utils/filters';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "../static/css/flex.css";
import '../static/css/init.css'
import '../static/css/modify.css'
import '../static/css/iconfont.css'
import qs from 'qs';
import 'babel-polyfill'
import VideoPlayer from 'vue-video-player'
import echarts from 'echarts'
import VCharts from 'v-charts'
// import VueKindEditor from 'vue-kindeditor'
import 'kindeditor/kindeditor-all-min.js'
import 'kindeditor/themes/default/default.css'
import vuePicturePreview from 'vue-picture-preview'
import VueDND from 'awe-dnd'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)


Vue.use(VueVideoPlayer)
Vue.use(vuePicturePreview)
Vue.use(VueDND)
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
Vue.use(VideoPlayer);
// Vue.use(VueKindEditor)

Vue.use(ElementUI);
Vue.use(VCharts);
Vue.config.productionTip = false;
Vue.prototype.http = http;
Vue.prototype.api = api;
Vue.prototype.qs = qs;
Vue.prototype.hbtjs = hbtjs;
Vue.prototype.$echarts = echarts
Vue.prototype.filters = filters;

// //使用钩子函数对路由进行权限跳转
// router.beforeEach((to, from, next) => {
//   if(navigator.userAgent.indexOf('MSIE') > -1 ){
//    alert('浏览器不兼容通知:组件不兼容IE9及以下浏览器，请使用更高版本的浏览器查看')
//   }else{
//     next();
//   }
// });


//过滤器统一处理加载
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


//router-link IE跳转兼容
if (
  '-ms-scroll-limit' in document.documentElement.style &&
  '-ms-ime-align' in document.documentElement.style
) { // detect it's IE11
  window.addEventListener("hashchange", function(event) {
    var currentPath = window.location.hash.slice(1);
    if (store.state.route.path !== currentPath) {
      router.push(currentPath)
    }
  }, false)
}



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js